import { render, staticRenderFns } from "./VisitorIdentification.vue?vue&type=template&id=f846fea2&"
import script from "./VisitorIdentification.vue?vue&type=script&lang=js&"
export * from "./VisitorIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports